import React from 'react'
import { Col } from 'react-bootstrap'

import { DATE_CHECKIN_FORMAT } from 'constants.js'
import { dateFormatter } from 'Utils/Formatters'
import { Section, SectionLabel, SectionRow } from 'Components/Section'
import Button from '@material-ui/core/Button'

import { ProfilePicture } from './style'
import ConfirmableTimePicker from './../../../../Components/Form/ConfirmableTimePicker'
import { processDate } from 'Utils/Date'
import { getBAName } from '../../../../Utils/User'
import { authorization } from '../../../../Module/Auth/Auth'

const MissionAmbassador = ({
  mission,
  onCheckInTimeChange,
  onCheckOutTimeChange,
  onNotifyMissionWasSpied,
  isLoading,
}) => {
  const showNotifyButton =
    authorization.isAdmin() ||
    authorization.isSpy() ||
    authorization.isCityManager()

  const showSpySection = mission.spyInformation && mission.spyInformation.spy
  const colWidth = showSpySection ? 3 : 4

  return (
    <Section title={'Brand Ambassador'}>
      <SectionRow>
        <Col xs={colWidth}>
          <SectionLabel>Full Name</SectionLabel>
          {getBAName({
            firstName: mission.user.firstName,
            lastName: mission.user.lastName,
            isTeamLeader: mission.user.isTeamLeader,
          })}
        </Col>
        <Col xs={colWidth}>
          <SectionLabel>Pay Ratio</SectionLabel>
          {mission.payoutRatio !== null && `${mission.payoutRatio} %`}
        </Col>
        <Col xs={colWidth}>
          <SectionLabel>Checkin</SectionLabel>
          {onCheckInTimeChange ? (
            <ConfirmableTimePicker
              pickerId="checkInTime"
              pickerName="Check In Time"
              pickerValue={processDate(mission.checkInTime)}
              minutesStep={1}
              onChange={onCheckInTimeChange}
              dialogTitle={mission.checkin.dialogTitle}
              initialDate={mission.recommendedCheckInTime.from}
            />
          ) : mission.checkInTime ? (
            dateFormatter(processDate(mission.checkInTime), DATE_CHECKIN_FORMAT)
          ) : (
            '-'
          )}
        </Col>
        {showSpySection && (
          <Col xs={colWidth}>
            <SectionLabel>Spy Check in</SectionLabel>
            {mission.spyInformation.spyDetails &&
            mission.spyInformation.spyDetails.checkInTime
              ? dateFormatter(
                  processDate(
                    Number(mission.spyInformation.spyDetails.checkInTime),
                  ),
                  DATE_CHECKIN_FORMAT,
                )
              : '-'}
          </Col>
        )}
      </SectionRow>
      <SectionRow>
        <Col xs={colWidth}>
          <ProfilePicture src={mission.user.profilePicture} />
        </Col>
        {!authorization.isClient() && !authorization.isClientAdmin() ? (
          <Col xs={colWidth}>
            <SectionLabel>Pay Adjustment Reason</SectionLabel>
            {mission.payoutRatioComment !== null
              ? mission.payoutRatioComment
              : '-'}
          </Col>
        ) : (
          <Col xs={colWidth} />
        )}
        <Col xs={colWidth}>
          <SectionLabel>Checkout</SectionLabel>
          {onCheckOutTimeChange ? (
            <ConfirmableTimePicker
              pickerId="checkOutTime"
              pickerName="Check Out Time"
              pickerValue={processDate(mission.checkoutTime)}
              minutesStep={1}
              onChange={onCheckOutTimeChange}
              dialogTitle={mission.checkout.dialogTitle}
              initialDate={mission.recommendedCheckInTime.from}
            />
          ) : mission.checkoutTime ? (
            dateFormatter(
              processDate(mission.checkoutTime),
              DATE_CHECKIN_FORMAT,
            )
          ) : (
            '-'
          )}
        </Col>
        {showSpySection && (
          <Col xs={colWidth}>
            <SectionLabel>Spy Check out</SectionLabel>
            {mission.spyInformation.spyDetails &&
            mission.spyInformation.spyDetails.checkoutTime
              ? dateFormatter(
                  processDate(
                    Number(mission.spyInformation.spyDetails.checkoutTime),
                  ),
                  DATE_CHECKIN_FORMAT,
                )
              : '-'}
          </Col>
        )}
      </SectionRow>
      {showNotifyButton && onNotifyMissionWasSpied && (
        <SectionRow thin={'true'}>
          <Col xs={12}>
            {mission.notifiedSuccessfullySpied ? (
              'Notified successfully spied ✅'
            ) : (
              <Button
                variant="contained"
                onClick={onNotifyMissionWasSpied}
                disabled={isLoading}
              >
                Notify successfully spied
              </Button>
            )}
          </Col>
        </SectionRow>
      )}
    </Section>
  )
}

export { MissionAmbassador }



// WEBPACK FOOTER //
// ./src/Containers/Mission/Details/MissionAmbassador/index.js